import { render, staticRenderFns } from "./kiosk-re-bank.vue?vue&type=template&id=dabf99b6&scoped=true&"
import script from "./kiosk-re-bank.vue?vue&type=script&lang=js&"
export * from "./kiosk-re-bank.vue?vue&type=script&lang=js&"
import style0 from "./kiosk-re-bank.vue?vue&type=style&index=0&id=dabf99b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dabf99b6",
  null
  
)

export default component.exports